import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ParamMap } from '@angular/router';
import { Observable, combineLatest, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { map, flatMap, tap, switchMap, switchAll, take } from 'rxjs/operators';
import { Survey } from '../models/survey/survey.model';
import { Booking } from '../models/booking.model';
import { User } from '../models/user.model';
import { UtilsService } from "./utils.service";
import { environment } from '../../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  //pass data to child routes
  //private survey:Subject<Survey> = new BehaviorSubject<Survey>( null );
  private survey:Subject<Survey> = new ReplaySubject<Survey>(1);
  survey$ = this.survey.asObservable();

  constructor( private http: HttpClient, private utilsService: UtilsService ) {
  }  

  addSurvey( survey: Survey) {
    this.survey.next( survey );
  }

  getSurveyBySurveyId( surveyId ) {

    const url = environment.apiUrl + '/surveys/' + surveyId;
    //const url = 'http://api.pricepilot.loc/app_dev.php/surveys/' + surveyId;

    return this.http.get( url ).pipe(
       map ( response => new Survey( response ) ),
       tap( survey => this.addSurvey(survey) )
    );

  }


  private composePostBody( survey: Survey, answersFormValues: any, booking: Booking) {

    let body:{ 
      booking: string, 
      yesNoAnswersData: { yes: boolean, question: string }[] 
      selectAnswersData: { selectQuestionOption: string, question: string }[] 
      essayAnswersData: { text: string, question: string }[] 
      ratingAnswersData: { score: number, question: string }[] 
    };

    body = {
      'booking': environment.apiUrl + '/users/' + booking.user.id + '/bookings/' + booking.id,
      'yesNoAnswersData': [],
      'selectAnswersData': [],
      'essayAnswersData': [],
      'ratingAnswersData': [],
    };
 
    console.log(survey.questions);

    let questionIdNumber: number;

    for( let question of survey.questions ) {

      questionIdNumber = parseInt(question.id);

      if ( undefined === answersFormValues[ questionIdNumber ] || null === answersFormValues[ questionIdNumber ] ) {
        continue;
      }

      switch( question.getClassName() ) {

        case 'EssayQuestion':

          body['essayAnswersData'].push({
            text: this.utilsService.filterEmojis(answersFormValues[ questionIdNumber ]),
            question: environment.apiUrl + '/surveys/' + survey.id + '/essayquestions/' + question.id
          });

          break;


        case 'YesNoQuestion':

          body['yesNoAnswersData'].push({
            yes: answersFormValues[ questionIdNumber ],
            question: environment.apiUrl + '/surveys/' + survey.id + '/yesnoquestions/' + question.id
          });

          break;


        case 'SelectQuestion':

          body['selectAnswersData'].push({
            selectQuestionOption: environment.apiUrl + '/surveys/' + survey.id + '/ratingquestions/' + question.id + '/ratingquestionoptions/' + answersFormValues[ questionIdNumber ],
            question: environment.apiUrl + '/surveys/' + survey.id + '/selectquestions/' + question.id
          });

          break;

        case 'RatingQuestion':

          body['ratingAnswersData'].push({
            score: answersFormValues[ questionIdNumber ],
            question: environment.apiUrl + '/surveys/' + survey.id + '/ratingquestions/' + question.id
          });

          break;

      }

    }

    return body;

  }


  saveSurvey$( survey: Survey, answersFormValues: any, code: string, booking: Booking ) {

    return this.http.post(
      environment.apiUrl + '/surveys/' + survey.id + '/takensurveys?code=' + code, 
      this.composePostBody( survey, answersFormValues, booking )
    );

  }


}
